import { useLocation } from "react-router-dom";
import BergEventLED from "./components/BergEventLED";
import "./App.css";
import "@berg-regions/berg-components/lib/index.css";
import FullscreenDisplay from "./components/FullscreenDisplay";

const App = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isFullscreen = searchParams.get("fullscreen") === "true";

  return (
    <div className={isFullscreen ? "fullscreen-mode" : "App"}>
      {isFullscreen ? (
        <FullscreenDisplay />
      ) : (
        <header className="App-header">
          <h1>BergEvent LED Display</h1>
          <div className="display-container">
            <BergEventLED />
          </div>
          <p className="display-info">
            Rozdzielczość: 1024 × 128 px (4m × 50cm)
          </p>

          <div className="display-controls">
            <button
              className="fullscreen-button"
              onClick={() => (window.location.href = "/?fullscreen=true")}
            >
              Tryb pełnoekranowy
            </button>
          </div>
        </header>
      )}
    </div>
  );
};

export default App;
